var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"power-container"},[_c('div',{staticClass:"power-areas"},[_c('CommonTree')],1),_c('div',{staticClass:"power-content"},[_c('ListCommon',{ref:"lightList1",staticClass:"light-control-list",attrs:{"type":_vm.args.type}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }